import { FilterExpressionType } from "./FilterExpressionType";

export const adaptFilterExpressionType = (type: FilterExpressionType): string => {
    switch (type) {
        case FilterExpressionType.contains:
            return "contains";
        case FilterExpressionType.greaterThan:
            return "gt";
        case FilterExpressionType.lessThan:
            return "lt";
        case FilterExpressionType.isTrue:
            return "equals";
        case FilterExpressionType.isFalse:
            return "equals";
        case FilterExpressionType.isNull:
            return "equals";
        case FilterExpressionType.isNotNull:
            return "not";
        case FilterExpressionType.equals:
        default:
            return "in";
    }
}


export const adaptFilterExpressionValue = (type: FilterExpressionType, value: unknown[]): unknown | unknown[] => {
    switch (type) {
        case FilterExpressionType.contains:
        case FilterExpressionType.greaterThan:
        case FilterExpressionType.lessThan:
            return value.length > 0 ? value[0] : "";
        case FilterExpressionType.isTrue:
            return true;
        case FilterExpressionType.isFalse:
            return false;
        case FilterExpressionType.isNull:
            return null;
        case FilterExpressionType.isNotNull:
            return null; // Will be used with "not" operator
        case FilterExpressionType.equals:
        default:
            return value.length > 0 ? value : "";
    }
}
